import { render, staticRenderFns } from "./EditCNICPromo.vue?vue&type=template&id=11ad6f5a"
import script from "./EditCNICPromo.vue?vue&type=script&lang=js"
export * from "./EditCNICPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports